import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yeydokmtpjglqmpgragc.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlleWRva210cGpnbHFtcGdyYWdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MTQzODUsImV4cCI6MjA1MzA5MDM4NX0.kwHOE8viTuhEJ5d47sSKyEs4BdCySd73kERVwMhGqrk";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Add error handling helper
export const handleSupabaseError = (error: any) => {
  console.error('Supabase error:', error);
  if (error.message === 'Failed to fetch') {
    console.error('Network error - check your connection and Supabase configuration');
  }
  throw error;
};